import styled from "styled-components";
import { media } from "../../../../components/common/media";
const Wrapper = styled.section`
  z-index: 1299;
  top: 0;
  position: relative;
  background: #ffffff;
  width: 100%;
  overflow: auto;
  min-height: 750px;
  .close-icon{
    font-size: 35px;
    right: 15px;
    top: 15px;
    z-index: 21;
    position: absolute;
    color: #a9a9a9;
    cursor: pointer;
  }
  .jukin-logo{
    position: absolute;
    top: 30px;
    left: 50px;
    cursor: pointer;
    z-index: 12;
    ${media.desktop`
      left: 30px;
    `}
    svg.logo {
      width: 34px;
      height: 31px;
    }
    .st0 {
      fill: #1EBEC8;
    }
    .st1 {
      fill: #fff;
    }
  }
`

export default Wrapper;